import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { SortType } from "../../SortType";

export interface OpsAnalyticsFilters {
  page: number;
  limit: number;
  search: string | null;
  poc_no: FilterValue[];
  order_id: FilterValue[];
  order_type: FilterValue[] | null;
  labels: FilterValue[];
  archived: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
  sortBy: string;
  sortType: SortType;
  excluded_orders: FilterValue | null;
  pm_adminids: FilterValue[];
  assignee_id: FilterValue[];
}

export interface OpsAnalyticsSelectedFilters {
  page: number;
  limit: number;
  search: string | null;
  poc_no: FilterValue[];
  order_id: FilterValue[];
  order_type: FilterValue[] | null;
  labels: FilterValue[];
  archived: FilterValue[] | null;
  start_date: string;
  end_date: string;
  sortBy: string;
  sortType: SortType;
  pm_adminids: FilterValue[];
  assignee_id: FilterValue[];
  excluded_orders: FilterValue | null;
}

export interface OpsAnalyticsAPIFilters {
  pm_adminids: FilterValue[] | null;
  archived: FilterValue[] | null;
  order_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  excluded_orders: boolean;
  start_date: string;
  end_date: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: "ASC" | "DESC";
  search?: string;
}

export function parseQueryParamsForOpsAnalyticsFilters(
  params: OpsAnalyticsFilters | null,
  query_params: URLSearchParams
): OpsAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    page: params?.page ?? 1,
    limit: params?.limit ?? 30,
    search: params?.search ?? "",
    poc_no: params?.poc_no ?? [],
    pm_adminids: params?.pm_adminids ?? [],
    assignee_id: params?.assignee_id ?? [],
    order_id: params?.order_id ?? [],
    labels: params?.labels ?? [],
    archived: params?.archived ?? [],
    order_type: params?.order_type ?? [],
    excluded_orders: params?.excluded_orders ?? null,
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    sortBy: params?.sortBy || "created_date",
    sortType: params?.sortType ?? SortType.DESC,
  };
}
